<div class="container">
    <div class="header">
        <span class="description">
            {{ 'duty-engineer.description' | translate: { count: engineerList?.length || 0 } }}
        </span>
        <div class="header-actions">
            <span
                class="edit-categories"
                data-cy="ops-settings-duty-engrs-edit-categories-button"
                [class.disabled]="engineerList.length === 0 || !userCanEdit"
                (click)="engineerList.length !== 0 && editCategories()">
                {{ 'duty-engineer.edit-categories' | translate }}
            </span>

            <app-button
                text="duty-engineer.add-engineer"
                [iconButton]="true"
                [noneMarginIcon]="true"
                iconSize="20px"
                icon="plus"
                [disable]="engineerList.length >= MAX_ENGINEER_COUNT || !userCanEdit"
                (onClick)="engineerList.length < MAX_ENGINEER_COUNT && addEngineer()"></app-button>
        </div>
    </div>

    <div class="category-header">
        <div class="category-tabs">
            <div
                *ngFor="let controlType of controlModeList"
                class="category-tab"
                [class.selected]="selectedControlMode === controlType"
                (click)="selectControlType(controlType)">
                <mat-icon *ngIf="selectedControlMode === controlType" svgIcon="check" class="check-icon"></mat-icon>
                <span class="category-name" data-cy="ops-settings-duty-engrs-control-type-toggle">{{
                    getControlModeLabel(controlType) | translate
                }}</span>
            </div>
        </div>

        <div class="help-container">
            <mat-icon svgIcon="help" class="help-icon"></mat-icon>

            <div class="message">
                <span
                    class="text"
                    [innerHTML]="
                        'duty-engineer.category.header.help.content'
                            | translate
                                : {
                                      category1: '<strong>' + ('duty-engineer.OPS.control' | translate) + '</strong>',
                                      category2:
                                          '<strong>' + ('duty-engineer.Console.control' | translate) + '</strong>',
                                  }
                    ">
                </span>
            </div>
        </div>
    </div>

    <div class="content">
        <div class="content-header">
            <div class="content-header-cell engineer-col">
                {{ 'duty-engineer.header.engineers' | translate }}
            </div>
            <div class="content-header-cell abbreviation-col">
                {{ 'duty-engineer.header.abbreviations' | translate }}
            </div>
            <div class="content-header-cell address-col" [class.address-dim]="isOpsControl">
                {{ 'duty-engineer.header.input-address' | translate }}
            </div>
            <div class="options content-cell"></div>
        </div>

        <div cdkDropList [cdkDropListData]="engineerList" (cdkDropListDropped)="graphDrop($event)" class="tab-list">
            <div
                *ngFor="let engineer of engineerList; let i = index"
                class="content-row"
                cdkDrag
                [cdkDragData]="graph"
                [class.disabled]="!userCanEdit">
                <div class="tab-placeholder" *cdkDragPlaceholder></div>
                <div class="content-cell engineer-col" data-cy="ops-settings-duty-engrs-name">
                    {{ engineer.name }}
                </div>
                <div class="content-cell abbreviation-col" data-cy="ops-settings-duty-engrs-abbrev">
                    {{ engineer.abbreviation }}
                </div>
                <div class="content-cell address-col" [class.address-dim]="isOpsControl">
                    <span *ngIf="isOpsControl">{{ 'duty-engineer.header.ops-control-dash' | translate }}</span>
                    <ng-container *ngIf="isConsoleControl">
                        <span *ngIf="engineer.inputAddress; else noAddress">{{ engineer.inputAddress }}</span>
                        <ng-template #noAddress>
                            <span
                                class="Medium clickable"
                                (click)="setInputAddress(engineer); $event.stopPropagation()"
                                >{{ 'duty-engineer.header.no-input-address' | translate }}</span
                            >
                        </ng-template>
                    </ng-container>
                </div>
                <div class="options content-cell">
                    <app-more-options-dropdown
                        [isOpen]="optionVisible === i"
                        (toggle)="openOptions(i)"
                        [options]="moreOptions"
                        (optionSelected)="onMoreOptionSelected($event, engineer)">
                    </app-more-options-dropdown>
                </div>
            </div>
        </div>
    </div>
</div>

<app-loading-spinner *ngIf="isLoading" class="spinner-component"></app-loading-spinner>
